module.exports = __webpack_public_path__ + "wxMicroService/img/get_gift.c966e6cb.jpg";